import React, { Dispatch, FC, useEffect } from 'react'
import './MinimumWageModal.scss'
import Modal from 'ps-components/Modal/Modal';
import ModalBody from 'ps-components/Modal/ModalBody/ModalBody';
import ModalFooter from 'ps-components/Modal/ModalFooter/ModalFooter';
import ModalHeader from 'ps-components/Modal/ModalHeader/ModalHeader';
import { editMinimumWage } from '../helpers';
import { useToast } from 'ps-shared-ui/v4/Toast';
import { MinimumWageForm } from './MinimumWageForm';
import { MinimumWageReducerAction, MinimumWageStateI } from '../store';
import { TOAST_ERROR_OPTIONS } from '../../../../../../constants';

interface EditMinimumWageModalPropsI {
  state: MinimumWageStateI
  dispatch: Dispatch<MinimumWageReducerAction>
}

export const EditMinimumWageModal: FC<EditMinimumWageModalPropsI> = ({ state, dispatch }) => {
  const { selectedRow, requestPending, modal } = state
  if (!selectedRow) return null

  const toast = useToast()
  const handleClose = () => dispatch({ type: 'SET_MODAL_CLOSED' })

  const handleSubmit = () => {
    if (isNaN(modal.form.minimum_wage as number) || modal.form.minimum_wage === '') return toast('Minimum Wage must be a number', TOAST_ERROR_OPTIONS)
    return editMinimumWage(modal.form, selectedRow, dispatch, toast)
  }

  useEffect(() => {
    dispatch({ type: 'SET_SELECTED_ROW', payload: selectedRow })
  }, [selectedRow])

  return (
    <div className='minimum-wage-modal'>
      <Modal onClose={handleClose} show={modal.open && modal.name === 'EDIT_WAGE'}>
        <ModalHeader>
          <h3 className='minimum-wage-modal__title'>
            Edit Minimum Wage
          </h3>
        </ModalHeader>
        <ModalBody>
          <MinimumWageForm formState={modal.form} dispatch={dispatch} />
        </ModalBody>
        <ModalFooter
          cancelBtnClick={handleClose}
          submitBtnClick={handleSubmit}
          submitBtnTxtName="Update"
          saveButtonDisabled={requestPending}
          hideCancelButton={requestPending}
          cancelBtnVariant='danger'
        />
      </Modal>
    </div>
  )
}
